/**
 * 画面上部に出す見出しを決める。
 *
 * ルート名は日本語のものと英語のものが混ざっている。UUIDのURL用に足した
 * Public* 系や、案内用の ProjectPrerequisiteRequired は英語名で、そのまま
 * 見出しに使うと利用者には PublicAdminRosterDetail と見えてしまう。
 *
 * 日本語の見出しは meta.pageTitle に持たせる。ルート名を日本語にすると、
 * 名前で分岐している guard や既存テストまで巻き込むため触らない。
 */
import { PRODUCT_NAME } from '@/common/productName'

export default function routePageTitle (route) {
  if (!route) return PRODUCT_NAME
  const meta = route.meta || {}
  return meta.pageTitle || route.name || PRODUCT_NAME
}
